module.exports = __webpack_public_path__ + "img/nodata.8c9db8cd.png";